import React from 'react';

const CarAssignMessage = ({ handleAssignClick }) => {
  return (
    <div className="flex flex-col items-center self-center gap-4">
      <h4>Πρόσθεσε οδηγούς</h4>
      <div>
      Η ενέργεια αυτή σού επιτρέπει να κλείσεις ραντεβού για service και να διαχειρίζεσαι τους οδηγούς του αυτοκινήτου.
      </div>
      <button
        type="button"
        className="btn-primary text-primary-button mt-4"
        onClick={handleAssignClick}
      >
        Προσθήκη
      </button>
    </div>
  );
};

export default CarAssignMessage;
